angular.module('TurneroApp').component('coGruposModificar', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '=',
    },
    controller: [
        'gruposService',
        'utilsService',
        'TurneroAppConstant',
        function (gruposService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.grupoEditar = {};
            ctrl.puestosModificar = [];

            ctrl.errores = {
                Puestos: false,
                N_Grupo: false,
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadModificar = function (item) {
                    ctrl.errores = {
                        Puestos: false,
                        N_Grupo: false,
                    };

                    if (item && item.Id_Grupo && ctrl.centroAtencionSeleccionado.id) {
                        gruposService.getInfo({
                            'id_Grupo': item.Id_Grupo,
                            'id_centro_atencion': ctrl.centroAtencionSeleccionado.id
                        }).$promise.then(function (data) {
                            ctrl.grupoEditar = data
                            ctrl.obtenerPuestoshabilitados(data)
                        }).catch(function (error) {
                            utilsService.errores(error);
                        });
                    }
                }
            }

            ctrl.cambiosEnPuestosEdit = function (item) {
                ctrl.grupoEditar.puestosModificar = item;
            };

            ctrl.obtenerPuestoshabilitados = function () {
                ctrl.puestosModificar = [];
                var Puestos = [];
                for (var i = 0; i < ctrl.grupoEditar.PuestosAsignados.length; i++) {
                    ctrl.puestosModificar.push({
                        'id': ctrl.grupoEditar.PuestosAsignados[i].Id_Puesto.toString(),
                        'text': ctrl.grupoEditar.PuestosAsignados[i].N_Puesto
                    });
                }
                for (var i = 0; i < ctrl.grupoEditar.Puestos.length; i++) {
                    Puestos.push({
                        'id': ctrl.grupoEditar.Puestos[i].id,
                        'text': ctrl.grupoEditar.Puestos[i].text
                    });
                }
                ctrl.grupoEditar.Puestos = Puestos;
            };

            ctrl.asignarAltasyBajas = function () {
                //limpio las listas, para que no quede basura en la variable del scope.
                ctrl.grupoEditar.Id_Grupo_Puesto_Baja = '';
                ctrl.grupoEditar.Id_Puesto_Alta = '';
                if (ctrl.grupoEditar.PuestosAsignados.length > 0) {
                    //en la lista de roles Usuarios, busco los que no estan en la lista de puestosModificar y los agrego para baja.
                    for (var i = 0; i < ctrl.grupoEditar.PuestosAsignados.length; i++) {
                        if (ctrl.grupoEditar.puestosModificar != undefined && ctrl.grupoEditar.puestosModificar != null) {
                            var existe = false;
                            for (var j = 0; j < ctrl.grupoEditar.puestosModificar.length; j++) {
                                if (ctrl.grupoEditar.puestosModificar[j].id == ctrl.grupoEditar.PuestosAsignados[i].Id_Puesto) {
                                    existe = true;
                                }
                            }
                            if (!existe) {
                                ctrl.grupoEditar.Id_Grupo_Puesto_Baja = ctrl.grupoEditar.Id_Grupo_Puesto_Baja + ctrl.grupoEditar.PuestosAsignados[i].Id_Grupo_Puesto;
                                ctrl.grupoEditar.Id_Grupo_Puesto_Baja = i == ctrl.grupoEditar.length - 1 ? ctrl.grupoEditar.Id_Grupo_Puesto_Baja : ctrl.grupoEditar.Id_Grupo_Puesto_Baja + ',';
                            }
                        }
                    }
                }

                if (ctrl.grupoEditar.puestosModificar != undefined && ctrl.grupoEditar.puestosModificar != null && ctrl.grupoEditar.puestosModificar.length > 0) {
                    //en la lista de roles modificados, busco los que no coinciden con RolesUsuarios y los agrego a la lista de Agregar.
                    for (var i = 0; i < ctrl.grupoEditar.puestosModificar.length; i++) {
                        var existe = false;

                        for (var j = 0; j < ctrl.grupoEditar.PuestosAsignados.length; j++) {
                            if (ctrl.grupoEditar.puestosModificar[i].id == ctrl.grupoEditar.PuestosAsignados[j].Id_Puesto) {
                                existe = true;
                            }
                        }
                        if (!existe) {
                            ctrl.grupoEditar.Id_Puesto_Alta = ctrl.grupoEditar.Id_Puesto_Alta + ctrl.grupoEditar.puestosModificar[i].id;
                            ctrl.grupoEditar.Id_Puesto_Alta = i == ctrl.grupoEditar.puestosModificar.length - 1 ? ctrl.grupoEditar.Id_Puesto_Alta : ctrl.grupoEditar.Id_Puesto_Alta + ',';
                        }
                    }
                }
                ctrl.grupoEditar.Id_Grupo_Puesto_Baja = ctrl.grupoEditar.Id_Grupo_Puesto_Baja.charAt(ctrl.grupoEditar.Id_Grupo_Puesto_Baja.length - 1) == ',' ? ctrl.grupoEditar.Id_Grupo_Puesto_Baja.slice(0, -1) : ctrl.grupoEditar.Id_Grupo_Puesto_Baja;
                ctrl.grupoEditar.Id_Puesto_Alta = ctrl.grupoEditar.Id_Puesto_Alta.charAt(ctrl.grupoEditar.Id_Puesto_Alta.length - 1) == ',' ? ctrl.grupoEditar.Id_Puesto_Alta.slice(0, -1) : ctrl.grupoEditar.Id_Puesto_Alta;
            };

            ctrl.guardarGrupoEditado = function () {
                ctrl.grupoEditar.Id_Centro_Atencion = ctrl.centroAtencionSeleccionado.id;
                ctrl.asignarAltasyBajas();

                ctrl.errores.N_Grupo = !(ctrl.grupoEditar.N_Grupo);
                ctrl.errores.Puestos = !(ctrl.grupoEditar.puestosModificar == undefined || ctrl.grupoEditar.puestosModificar.length > 0)
                if (ctrl.errores.N_Grupo || ctrl.errores.Puestos) {
                    return;
                }

                gruposService.update(ctrl.grupoEditar).$promise.then(function (res) {
                    ctrl.ctrlPadre.grillaReload();
                    sweetAlert("Modificar Grupo", "El grupo se modificó correctamente", "success");
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            };

            ctrl.cancelar = function () {
                ctrl.ctrlPadre.grillaReload();
            }
        }
    ],
    template: require('./gruposModificar.html')
});


// WEBPACK FOOTER //
// ./app/components/grupos/gruposModificarComponent.js